<template>
    <div>
        <el-dialog :title="dialogTitle" :visible.sync="visible" :top="'5vh'" width="80%" class="BorderRadius" :before-close="CloseDig"
            :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false">
            <div class="MaxHei">
                <div class="footer" v-if="SysCode!='org' && Type == 'Add'">
                    <el-button v-throttle size="small" type="primary" @click="SeleUser('File')">导入</el-button>
                    <el-button v-throttle size="small" type="primary" @click="SeleUser('DownMol')">下载模板</el-button>
                </div>
                <div class="footer" v-if="Type == 'Lock'&&SysCode!='expert_portal'">
                    <el-button v-throttle size="small" type="primary" @click="DownField">下载</el-button>
                </div>
                <div class="DigItem Red MarTop" v-if="rowData.reject_reason">
                    <div class="DigItemWidTit MarRt10">形式审查意见</div>
                    <div>{{rowData.reject_reason}}</div>
                </div>
                <div class="DigItem MarTop">
                    <div class="DigItemWidTit MarRt10"><span class="Red">*</span>标题</div>
                    <el-input :readonly="Type === 'Lock'" class="Wid" size="medium" :placeholder="SysCode=='org' || AdminCode =='org'?'仅填写：医院名称+科室  例如：A医院B科室':'请输入名称'"
                        v-model="newData.record_name"></el-input>
                </div>
                <div class="DigItem" v-if="Type=='Add'">
                    <div class="DigItemWidTit MarRt10"><span class="Red">*</span>申请类型</div>
                    <el-select class="Wid" size="medium" v-model="FieldType" placeholder="请选择申请类型" @change="SetData">
                        <el-option v-for="item in rowtype" :key="item.id" :label="item.group_name":value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="DigItem" v-for="(item,i) in rowData.group" :key="item.id">
                    <div class="DigItemWidTitWid MarRt10" v-if="item.field_type == 'title'">
                        {{ item.field_label }}
                    </div>
                    <div class="DigItemWidTit MarRt10" v-else>
                        <span class="Red" v-if="item.is_required">*</span>{{ item.field_label }}
                    </div>
                    <el-input :readonly="Type === 'Lock'" v-if="item.field_type == 'text'" class="Wid" size="medium"
                        :placeholder="item.placeholder" v-model="item.default_value"></el-input>
                    <el-input :readonly="Type === 'Lock'" v-if="item.field_type == 'textarea'" class="Wid" size="medium"
                        type="textarea" :rows="8" :placeholder="item.placeholder" v-model="item.default_value"></el-input>
                    <template v-if="item.field_type == 'select'">
                        <el-select :disabled="Type === 'Lock'" class="Wid" size="medium" v-model="item.default_value"
                            :placeholder="item.placeholder">
                            <el-option v-for="items in item.field_options" :key="items.label" :label="items.label":value="items.label"></el-option>
                        </el-select>
                    </template>
                    <template v-if="item.field_type == 'radio'">
                        <el-radio-group :disabled="Type === 'Lock'" v-model="item.default_value">
                            <el-radio v-for="items in item.field_options" :key="items.label"
                                :label="items.label">{{ items.label }}</el-radio>
                        </el-radio-group>
                    </template>
                    <template v-if="item.field_type == 'checkbox'">
                        <el-checkbox-group :disabled="Type === 'Lock'" size="medium" v-model="item.default_value">
                            <el-checkbox v-for="items in item.field_options" :label="items.label"
                                :key="items.label">{{ items.label }}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                    <template v-if="item.field_type == 'date'">
                        <el-date-picker size="medium" class="Wid" :readonly="Type === 'Lock'" v-model="item.default_value"
                            type="date" :placeholder="item.placeholder"></el-date-picker>
                    </template>
                    <template v-if="item.field_type == 'cascader'">
                        <el-cascader :disabled="Type === 'Lock'" class="Wid" size="medium" v-model="item.default_value" :options="item.field_options" :placeholder="item.placeholder"
                        :props="{value:'label',label: 'label'}"
                        clearable filterable></el-cascader>
                    </template>
                    <template v-if="item.field_type == 'file'">
                        <el-upload v-if="Type != 'Lock' && !item.default_value" action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res, item)">
                            <el-button v-throttle class="BgColor" size="small" type="info">{{ item.placeholder?item.placeholder:'上传' }}</el-button>
                            <span> 文件上传限制500M以内</span>
                            <el-button v-if="item.moban_url" v-throttle size="small" type="primary" @click="LockUrl(item.moban_url)">下载模板</el-button>
                        </el-upload>
                        <div v-if="item.default_value">
                            <span>文件</span>
                            <el-tooltip effect="dark" content="查看文件" placement="top-start">
                                <i class="NavIcon el-icon-view" @click="LockUrl(item.default_value)"></i>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="删除文件" placement="top-start">
                                <i v-if="Type != 'Lock'" class="NavIcon el-icon-delete"
                                    @click="item.default_value = ''"></i>
                            </el-tooltip>
                        </div>
                    </template>
                    <template v-if="item.field_type == 'img_text'">
                        <div class="Wid">
                            <div class="DisFlex">
                                <el-button class="BgColor" size="small" type="primary" @click="AddImgFile(i)" :disabled="item.default_value.length>=item.upper_limit || Type === 'Lock'">添加</el-button>
                                <el-tag type="info" class="MarLt">图文上传限制500M以内 最多上传{{item.upper_limit}}张图片描述</el-tag>
                            </div>
                            <div class="DisFlex MarTop" v-for="(items, is) in item.default_value">
                                <div class="DisFlex" v-if="items.img_url">
                                    <el-image :preview-src-list="[$Tools.ServeUrl()+items.img_url]" class="ImgPos" :src="$Tools.ServeUrl()+items.img_url" fit="contain"></el-image>
                                </div>
                                <el-upload v-else action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res, item,is)" :disabled="Type === 'Lock'">
                                    <div class="ImgPos">上传图片</div>
                                </el-upload>
                                <el-input type="textarea" :rows="8" :readonly="Type === 'Lock'" size="medium" :placeholder="'图片'+(is+1)+'相关描述'" v-model="items.img_desc"></el-input>
                                <el-button v-if="Type != 'Lock'" size="small" type="danger" @click.stop="RemoveImgFile(i,is)">删除</el-button>
                            </div>
                        </div>
                    </template>
                    <template v-if="item.field_type == 'area'">
                        <el-cascader :disabled="Type === 'Lock'" class="Wid" :options="CityList" v-model="item.default_value" size="medium" :placeholder="item.placeholder"
                        :props="{value:'name',label: 'name',children: 'children'}"
                        clearable filterable></el-cascader>
                    </template>
                </div>
                <div class="DigItem" v-if="!BaoCun">
                    <div class="DigItemWidTit MarRt10" v-if="Admin || rowData.gl_file.length>0">附件</div>
                    <div class="DisFlex">
                        <div class="DisFlex">
                            <div class="FuJianPos" v-for="(item, i) in rowData.gl_file" @click="LockUrl(item)">
                                附件{{ i + 1 }}
                                <i v-if="Type != 'Lock'" class="NavIcon el-icon-circle-close FuJianAbs"
                                    @click.stop="RemoveFile(i)"></i>
                            </div>
                        </div>
                        <el-upload v-if="Type != 'Lock'" action="none" :show-file-list="false"
                            :http-request="(res) => UploadFlie(res, 'File')">
                            <el-button v-throttle class="BgColor" size="small" type="info">上传</el-button>
                            <span> 附件上传限制500M以内</span>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div slot="footer" v-if="Type != 'Lock'">
                <el-button v-throttle size="small" @click="CloseDig">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="info" @click="SucData(0)" v-if="BaoCun">保存</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucData(1)">{{rowData.status?'已修改，再次提交':'提交'}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="DownData.Type=='Down'?'下载模板':'导入'" :visible.sync="DownData.Blon" width="40%" class="BorderRadius" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">类型：</div>
                <el-select class="Wid120" size="medium" v-model="DownData.Id" clearable placeholder="类型">
                    <el-option v-for="i in rowtype" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
            </div>
            <div slot="footer">
                <div class="footer">
                    <el-button v-throttle size="small" @click="$Tools.ResetData(DownData)">取消</el-button>
                    <el-button v-if="DownData.Type =='Down'" v-throttle class="BgColor" size="small" type="primary" @click="DownSuc">确定</el-button>
                    <el-upload class="MarLt" v-else action="none" :show-file-list="false" :http-request="DaoRuFlie">
                        <el-button v-throttle size="small" type="primary">确定</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "RecordDialog",
        props: {
            // 弹窗显隐状态 (父组件传值)
            visible: {
                type: Boolean,
                default: false,
            },
            // 类型：Add=新增 Edi=编辑 Lock=查看
            Type: {
                type: String,
                default: "Add",
                validator: (val) => ["Add", "Edi", "Lock"].includes(val),
            },
            rowtype:{
                type: Array,
                default:() => [],
            },
            rowData: {
                type: Object,
                default: () => ({
                    group: [],
                    gl_file: []
                }),
            },
            // 基础数据 包含id和标题
            newData: {
                type: Object,
                default: () => ({
                    id: "",
                    record_name: ""
                }),
            },
            BaoCun:{
                type: Boolean,
                default: true,
            },
            sysType:{
                type: String,
                default: "",
            },
        },
        data() {
            return{
                CityList:"",
                FieldType:"",
                DownData:{
                    Blon:false,
                    Type:"Down",
                    Id:"",
                },
                SysCode:sessionStorage.getItem('SYSTEM-TOKEN'),
                AdminCode:localStorage.getItem('ApiType'),
                Admin:this.$Tools.localData('g')==1?true:false,
                ApiType:this.$Tools.localData("ApiType"),
            }
        },
        mounted() {
            this.CityList = JSON.parse(this.$Tools.localData("City"));
        },
        computed: {
            // 根据Type自动计算弹窗标题，无需父组件传标题
            dialogTitle() {
                switch (this.Type) {
                    case "Add":
                        return "新增";
                    case "Edi":
                        return "修改";
                    case "Lock":
                        return "查看";
                    default:
                        return "";
                }
            },
        },
        methods: {
            SetData(row){
                if(!this.newData.record_name){
                    if(this.SysCode !='record' && this.AdminCode !='record'){
                        this.FieldType = "";
                        this.$message.error("请填写标题后再申请类型");
                        return
                    }
                };
                var url = this.BaoCun?'/api/record/all':'admin/record/all'
                this.$get(url,{
                    id:row,
                    SystemCode:this.$Tools.localData("ApiType"),
                    system_sub_id:this.sysType,
                    name:this.newData.record_name,
                }).then(res=>{
                    if(res){
                        this.rowData.group = res.data.list.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = [];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            if(item.field_type == 'img_text'){item.default_value = [{"img_url":"","img_desc":""}]}
                            return item;
                        })
                        // if(this.SysCode=='org'){
                        //     var Json = JSON.parse(sessionStorage.getItem('USER-Info')).user_info;
                        //     this.newData.record_name = Json.work_unit + Json.department;
                        // }
                    }
                }).catch(err=>{
                    this.FieldType = "";
                    this.rowData.group= [];
                })
            },
            // 关闭弹窗 - 触发父组件的取消事件
            CloseDig() {
                this.FieldType = "";
                this.$emit("cancel");
            },
            // 提交/保存 - 触发父组件的提交事件，携带状态n 0=保存 1=提交
            SucData(n) {
                let rule = false;
                let str = "";
                const query = this.rowData.group.reduce((obj, item) => {
                    if (item.is_required && !item.default_value) {rule = true;str = item.field_label;}
                    obj[item.field_name] = item.field_type == "checkbox" ? item.default_value.join(",") : item.default_value;
                    return obj;
                }, {});
                query.sq_status = n;
                query.record_name = this.newData.record_name;
                query.gl_file = this.rowData.gl_file?this.rowData.gl_file.join(','):"";
                query.id = this.Type !== "Add"?this.newData.id:this.FieldType;
                query.system_sub_id=this.sysType;
                if (rule&&n==1) {
                    this.$message.error("带*为必填项，"+str+"未填写完成");
                    return;
                }
                if(!query.record_name){
                    this.$message.error("标题为必填，请填写完成");
                    return;
                }
                // this.FieldType = "";
                console.log(query)
                this.$emit("submit", query, n);
            },
            // 文件上传 - 触发父组件的上传事件
            UploadFlie(row,item,i){
                console.log(item)
                var file = row.file;
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                const MAX_SIZE = 100 * 1024 * 1024 * 5;
                const fileSize = file.size;
                if (fileSize > MAX_SIZE) {
                    this.$message.error(`文件大小超出限制！最大支持500M，当前文件大小：${(fileSize / 1024 / 1024).toFixed(2)}M`);
                    return;
                }
                const suffixStr = item.validation_type&&item.validation_type!="none"?item.validation_type_data.example:"";
                const fileName = file.name;
                if(suffixStr){
                    const allowSuffix = suffixStr.split('/');
                    // 获取文件小写后缀
                    const fileSuffix = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
                    // 判断是否在允许列表内
                    if(!allowSuffix.includes(fileSuffix)){
                        loading.close();
                        this.$message.error(item.message || `仅支持${suffixStr}格式文件`);
                        return;
                    }
                }

                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    fd.append('leixing',item.validation_type);
                    this.$post("/common/upload/image",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        if(item!="File"){
                            if(item.field_type =="img_text"){
                                item.default_value[i].img_url= res.data.url;
                            }else{
                                item.default_value = res.data.url;
                            }
                        }else{
                            this.rowData.gl_file.push(res.data.url);
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            RemoveFile(i){
                this.rowData.gl_file.splice(i,1);
            },
            RemoveImgFile(i,is){
                this.rowData.group[i].default_value.splice(is,1);
            },
            AddImgFile(i){
                this.rowData.group[i].default_value.push({"img_url":"","img_desc":""});
            },
            // 查看文件链接 - 触发父组件的查看链接事件
            LockUrl(url){
                var str = "";
                if(url.indexOf('http') == 0){
                    str = url;
                }else{
                    str = this.$Tools.ServeUrl()+url;
                }
                window.open(str)
            },
            SeleUser(type){
                if(type == "DownMol"){
                    this.DownData.Type = "Down";
                };
                if(type == "File"){
                    this.DownData.Type = "File";
                };
                this.DownData.Blon = true;
                this.DownData.Id = ""; 
            },
            DownSuc(){
                var url = this.BaoCun?'/api/record/moban':'admin/record/moban'
                this.$get(url,{
                    SystemCode:this.ApiType,
                    group_id:this.DownData.Id,
                    system_sub_id:this.sysType,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.$Tools.ResetData(this.DownData)
                        window.open(res.data.download_url)
                    }
                })
            },
            DownField(){
                var url = this.$Tools.localData('g')==1?'/admin/record/wordExport':'/api/record/wordExport';
                this.$get(url,{
                    id:this.rowData.id,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        window.open(res.data.download_url)
                    }
                })
            },
            DaoRuFlie(res){
                var file = res.file;
                if (this.$Tools.ChangeExcel(file)) {
                    this.$message.error('只能上传Excel文件格式 (.xls, .xlsx, .xlsm, .xlsb)');
                    return false;
                }
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    var url = this.BaoCun?'/api/record/daoru':'admin/record/daoru'
                    var fd = new FormData()
                    fd.append('file',file);
                    fd.append('SystemCode',this.ApiType);
                    fd.append('group_id',this.DownData.Id);
                    fd.append('system_sub_id',this.sysType);
                    this.$post(url,fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.$message.success(res.msg);
                    }).catch((res)=>{
                        loading.close();
                    })
                } catch (error) {
                    loading.close();
                }
                this.$Tools.ResetData(this.DownData)
            },
        },
    };
</script>

<style scoped>
    .MarLt{
        margin-left: 10px;
    }
    .MarTop{
        margin-top: 10px;
    }
    .MaxHei {
        max-height: 500px;
        overflow-y: auto;
    }
    .FieldBtns{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .DisFlex {
        display: flex;
        align-items: center;
    }
    .ImgPos {
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianPos {
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }

    .FuJianAbs {
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }

    .Red {
        color: red;
    }

    .Wid {
        width: calc(100% - 120px);
    }

    .DigItemWidTit {
        width: 120px;
        flex-shrink: 0;
    }
    .DigItemWidTitWid {
        margin-left: 100px;
        flex-shrink: 0;
        font-weight: 700;
    }
    .footer{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
</style>